export default {
  name: 'sa-oblivion-hagoromo',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_PENT: 'accent'
  }
};
